var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaviconIndorPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: "32px",
    height: "32px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3200 3200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E61400",
    d: "M500 0l2200 0c275,0 500,225 500,500l0 1600c0,275 -225,500 -500,500l-100 0 0 600 -600 -600 -1500 0c-275,0 -500,-225 -500,-500l0 -1600c0,-275 225,-500 500,-500z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "white",
    points: "2450,350 831,1142 1680,1504 750,2250 2369,1458 1446,1103 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconIndorPower);
export default __webpack_public_path__ + "static/media/favicon_indor_power.009ada730872f672be711c93bf84937e.svg";
export { ForwardRef as ReactComponent };